const isDict = (value) => value !== null && typeof value === "object";
// Backend localizations store keys with literal dots (e.g. `telemetries.foo.true`),
// while static locale JSON files use nested objects. Try the flat key first, then
// fall back to walking the dot path through nested objects.
const resolveMessage = (obj, path) => {
	if (!isDict(obj)) return null;
	const flatHit = obj[path];
	if (flatHit !== undefined) return flatHit;
	let current = obj;
	for (const key of path.split(".")) {
		if (!isDict(current)) return null;
		current = current[key];
	}
	return current ?? null;
};
export default () => ({ messageResolver: resolveMessage });
